import * as React from 'react';

import * as styles from './styles.css';

export interface IMobileTgbParams {
  type: 'tgb';

  image: string;
  title: string;
  description: string;
  phone: string;
  footnote?: string;
  url: string;
  label?: string;
}

export class MobileTgb extends React.PureComponent<IMobileTgbParams, {}> {
  public render(): React.JSX.Element {
    const { image, title, description, phone, footnote, url, label } = this.props;

    return (
      <div className={styles['outer']}>
        <a href={url} target="_blank" rel="noopener noreferrer nofollow" className={styles['container']}>
          <div className={styles['wrapper']}>
            <img src={image} alt={title} />
            <div className={styles['aside']}>
              {label && <div className={styles['label']}>{label}</div>}
              <h4 className={styles['title']}>{title}</h4>
              <p className={styles['text']}>{description}</p>
              {phone && <div className={styles['phone']}>{phone}</div>}
            </div>
          </div>
          {footnote && <div className={styles['note']}>{footnote}</div>}
        </a>
      </div>
    );
  }
}
